__turbopack_context__.v({
  "actions": "BzcTRa_actions",
  "content": "BzcTRa_content",
  "illustration": "BzcTRa_illustration",
  "title": "BzcTRa_title",
  "wrapper": "BzcTRa_wrapper",
});
